import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { customFormatclass, customClassSummary } from 'Components/GDTable/GDCustomFormat/GDCustomFormat';
import { numberWithCommas } from 'Utils/formatting.js';
import './DisplayPanel.scss';


class DisplayPanel extends React.Component {
  render() {
    return (
      <ul className="display-panel-wrapper-list" style={{ width: this.props.size, marginLeft: this.props.marginLeft }}>
        {
          this.props.structure.map((column, index) => {
            let valueClass;
            if (this.props.data !== undefined && this.props.data[column.columnKey] !== undefined) {
              if ((column.displayType === 'CURRENCY' || column.displayType === 'NEGATIVE_NUMBER') && Number.parseFloat(this.props.data[column.columnKey]) < 0) {
                valueClass = customFormatclass(customClassSummary, column.displayType);
              } else if (column.displayType === 'BALANCE_AMOUNT') {
                valueClass = parseFloat(this.props.balanceAmount.amount, 10) ? 'large-amount balance-amount-danger' : 'large-amount balance-amount-success';
              } else if (this.props.data[column.columnKey] && Number.parseFloat(this.props.data[column.columnKey].amount) < 0) {
                valueClass = customFormatclass(customClassSummary, column.displayType);
              }
            }
            const handlePrecision = (amount, precision) => {
              if (amount !== undefined && amount !== null) {
                const arr = `${amount}`.split('.');
                return arr.length > 1
                  ? `${arr[0] <= 0 ? arr[0] * -1 : arr[0]}.${arr[1].length === 1 ? `${arr[1]}0` : arr[1].substr(0, precision)}`
                  : `${amount <= 0 ? amount * -1 : amount}.00`;
              }
              return '--';
            };
            const handleEmptyValues = (dataVal) => {
              if (dataVal === null || dataVal === undefined) { return '--'; } else { return dataVal; }
            };
            let value;
            let currencyCode;
            if (this.props.data !== undefined && this.props.data[column.columnKey] !== undefined && this.props.data[column.columnKey] !== null && column.displayType === 'CURRENCY') {
              value = handlePrecision(this.props.data[column.columnKey].amount, 2);
              value = numberWithCommas(value);
              // Here is the comma seprator
              currencyCode = this.props.data[column.columnKey].currency;
            } else if (this.props.data !== undefined && this.props.data[column.columnKey] !== undefined && column.displayType === 'BALANCE_AMOUNT') {
              value = handlePrecision(parseInt(this.props.balanceAmount.amount, 10) < 0 ? this.props.data.caseAmount.amount : this.props.balanceAmount.amount, 2);
              value = numberWithCommas(value);
              // Here is the comma seprator
              currencyCode = this.props.data[column.columnKey].currency;
            } else if (this.props.data[column.columnKey] === undefined || this.props.data[column.columnKey] === null) {
              value = '--';
            } else if (column.displayType === 'STRING') {
              value = handleEmptyValues(this.props.data[column.columnKey]);
            } else if (column.displayType === 'NEGATIVE_NUMBER') {
              value = handlePrecision(this.props.data[column.columnKey], 2);
            } else if (column.displayType === 'ACCOUNTNUMBER') {
              value = (
                <GDAccountNumberCell
                  accountNumber={(this.props.data[column.columnKey]) === undefined || (this.props.data[column.columnKey]) === null ? '--' : (this.props.data[column.columnKey])}
                  token={this.props.data[column.secondaryColumnKey === undefined ? 'globalToken' : column.secondaryColumnKey]}
                />
              );
            } else if (column.displayType === 'INDICATOR') {
              value = this.props.data[column.columnKey] === '1' ? 'Y' : 'N';
            } else if (column.displayType === 'DATE') {
              const date = moment(this.props.data[column.columnKey]);
              value = date.format(this.props.dateFormat);
            } else {
              value = this.props.data[column.columnKey];
            }
            return (
              <li
                className={this.props.customClass ? 'display-panel-wrapper-smallbox-item' : 'display-panel-wrapper-list-item'}
                key={column.columnKey}
              >
                <div className="display-panel-wrapper-list-item-wrapper">
                  <span className="display-panel-wrapper-list-item-label">
                    {column.name}
                  </span>
                  {(column.displayType !== 'CURRENCY' && column.displayType !== 'BALANCE_AMOUNT') && <span className={valueClass || 'display-panel-wrapper'}>{value}</span>}
                  {(column.displayType === 'CURRENCY' || column.displayType === 'BALANCE_AMOUNT')
                    && (
                      <div className="currency-div">
                        <span className={valueClass || `display-panel-wrapper-amount-value ${this.props.customClass}`}>
                          {value}
                          {' '}
                        </span>
                        {this.props.data.caseAmount && this.props.data.caseAmount.currency && <span className="currency-code display-panel-wrapper-amount-unit">{column.displayType === 'BALANCE_AMOUNT' ? this.props.data.caseAmount.currency : currencyCode}</span>}
                      </div>
                    )
                  }
                </div>
              </li>
            );
          })
        }
      </ul>
    );
  }
}

DisplayPanel.propTypes = {
  dateFormat: PropTypes.string,
  structure: PropTypes.array.isRequired,
  size: PropTypes.string,
  data: PropTypes.object,
  customClass: PropTypes.string,
  balanceAmount: PropTypes.object,
  marginLeft: PropTypes.string,
};

DisplayPanel.defaultProps = {
  dateFormat: 'MM/DD/YYYY',
  data: {},
  customClass: '',
};

export default (DisplayPanel);
